import { render, staticRenderFns } from "./RelationshipDetails.vue?vue&type=template&id=b0a38872&"
import script from "./RelationshipDetails.vue?vue&type=script&lang=js&"
export * from "./RelationshipDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports